import { UIEvent, useEffect, useLayoutEffect, useRef } from "react";
import styles from "./ScrollView.module.css";

interface POIScrollViewProps {
    renderItem: (item: any, index: number) => JSX.Element;
    renderData: any; // 렌더링 할 데이터
    //page: number; // 현재 페이지
    isTop: () => void; // scroll 최상단에 도달했을 때 호출되는 함수
    isBottom: () => void; // scroll 최하단에 도달했을 때 호출되는 함수
    scrollPos: number | null;
}

/**
 * @remark 지도 화면 내 목록 스크롤 뷰
 * @returns <POIScrollView>
 * 렌더링, 스크롤 감지
 */

const POIScrollView = (props: POIScrollViewProps) => {
    const listRef = useRef<HTMLDivElement>(null); // 스크롤 컨테이너 참조
    // const [scrollPos, setScrollPos] = useState<number>(-1); // 새로 데이터를 채운 뒤 포커스할 인덱스

    // // 목록 내 데이터 변경 후, 이전 위치로 스크롤 복원
    // useLayoutEffect(() => {
    //     // if (!listRef.current || scrollPos < 0 || loadOption.page < 1) return;
    //     if (!listRef.current || props.scrollPos < 0) return;
    //     const scrollTarget = listRef.current.children[props.scrollPos] as HTMLElement;

    //     if (scrollTarget) {
    //         scrollTarget.scrollIntoView({ block: "center" });
    //     }
    // }, [props.renderData]);

    useEffect(() => {
        if (!listRef.current) return;
        if (props.scrollPos == null || props.scrollPos < 0) return;
    
        const target = listRef.current.children[props.scrollPos] as HTMLElement | undefined;
        if (target) {
          // block: "center"는 레이아웃 변동에 민감할 수 있어 start 권장
          target.scrollIntoView({ block: "start" });
        }
      }, [props.scrollPos]);

    

    // useEffect(() => {
    //     setScrollPos(props.scrollPos);
    // },[props.scrollPos])

    /**
     * 스크롤 이벤트: 상/하단 경계 인식
     */
    const onScroll = (e: UIEvent<HTMLDivElement>) => {
        const { scrollTop, offsetHeight, scrollHeight } = e.currentTarget;
        const isBottom = scrollTop + offsetHeight >= scrollHeight - 1;

        if (scrollTop === 0) {
            props.isTop();
        } else if (isBottom) {
            props.isBottom();
        }
    };

    return (
        <div className={`${styles.scroll}`} onScroll={onScroll} ref={listRef}>
            {props.renderData &&
                (props.renderData.length === 0 ? (
                    <div className={`${styles.contents}`}>{"조회된 데이터가 없습니다."}</div>
                ) : (
                    props.renderData.map((item: Object, index: number) => {
                        return props.renderItem(item, index);
                    })
                ))}
        </div>
    );
};

export default POIScrollView;
